import { useNavigate } from "react-router-dom";
import { Table } from "src/components/organisms/Table";
import {
  jobNumberColumn,
  tickerColumn,
  typeColumn,
  recordDateColumn,
  stageColumn,
} from "src/components/organisms/Table/columns";
import { ProxyEventResult } from "src/store/globalSearch/types";

interface Props {
  proxyEvents: ProxyEventResult[];
  closeSearchDrawer: () => void;
}

export const SearchProxyEventResults = ({
  proxyEvents,
  closeSearchDrawer,
}: Props) => {
  const navigate = useNavigate();

  if (proxyEvents.length === 0) {
    return null;
  }

  return (
    <Table
      data={proxyEvents}
      columns={[
        jobNumberColumn,
        tickerColumn,
        typeColumn,
        recordDateColumn,
        stageColumn,
      ]}
      rowOnClick={(event) => {
        navigate(`/proxy-events/${event.id}/details`);
        closeSearchDrawer();
      }}
    />
  );
};
